import React, { useState, useEffect } from "react";
import PropertiesService from "../../../Services/PropertiesService";
import { showErrorToast, showSuccessToast } from "../../../Constant/Notification";
import { MdAddCircleOutline } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import ApartmentUnitForm from "./ApartmentUnitForm";
import { plotStatusIds, roadFacingSides } from "../../../../Enum";
import { userUid } from "../../../Constant/Constant";
import { IoDocumentLockOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { RiFileInfoLine } from "react-icons/ri";

const ApartmentUnitTable = ({
  towers,
  propertyId,
  totalUnitsPerTower,
  selectedTowerId,
  onTotalUnitsChange,
  onAdd,
  onEdit,
  handleSetLoading,
  isEdit,
  lastUnitTrigger = false,
}) => {
  const [selectedTower, setSelectedTower] = useState(towers[0]?.id || "");
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [editingUnit, setEditingUnit] = useState(null);
  const [isNewUnit, setIsNewUnit] = useState(false);
  const [localUnits, setLocalUnits] = useState([]);
  const [exitingTotalUnits, setExitingTotalUnits] = useState(0);
  const [totalUnits, setTotalUnits] = useState(
    totalUnitsPerTower[towers[0]?.towerNum] || 0
  );
  const [loading, setLoading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const navigate = useNavigate();
  

  useEffect(() => {
    setTotalUnits(totalUnitsPerTower[towers[0]?.towerNum] || 0);
    if (selectedTower) {
      selectedTowerId(selectedTower);
      fetchUnitsForTower(selectedTower);
      const tower = towers.find((t) => t.id === selectedTower);
      // setTotalUnits(totalUnitsPerTower[tower?.towerNum] || 0);
      setTotalUnits(0)
    }
  }, [selectedTower]);

  useEffect(() => {
    if (localUnits?.length > 0) {
      setTotalUnits(localUnits?.length);
    }
  }, [totalUnitsPerTower, towers]);

  useEffect(() => {

    if (lastUnitTrigger && hasChanges) {
      saveUnitsForTower(selectedTower);
    }
  }, [lastUnitTrigger]);


  const fetchUnitsForTower = async (towerId) => {

    setLoading(true);
    try {
      const unitsResponse = await PropertiesService.getApartmentUnitsByPropertyId(
        propertyId,
        towerId
      );
      const unitsData = unitsResponse.data?.units || [];
      const mappedUnits = unitsData.map((unit, index) => ({
        ...unit,
        order: index + 1,
        floors: unit.unitFloor || 0,
        towerId: towerId,
        towerNum: towers.find((t) => t.id === towerId)?.towerNum || 1,
        isArchived: false,
      }));
      setLocalUnits(mappedUnits);

      setExitingTotalUnits(unitsData?.length);
      const tower = towers.find((t) => t.id === towerId);
      if (tower) {
        onTotalUnitsChange(tower.towerNum, mappedUnits.filter((u) => !u.isArchived).length);
      }
      setHasChanges(false);
    } catch (error) {
      console.error("Error fetching units:", error);

    } finally {
      setLoading(false);

    }
  };

  const saveUnitsForTower = async (towerId) => {
    handleSetLoading(true)
    setLoading(true);
    try {
      const validUnits = localUnits.filter(
        (unit) =>
          unit &&
          unit.unitNo?.trim() &&
          unit.buildUpArea > 0 &&
          !unit.isArchived
      );

      if (validUnits.length === 0 && localUnits.some((unit) => unit !== null)) {
        showErrorToast("All units must have a valid unit number and build-up area!");
        return;
      }

      const updatedUnits = validUnits.map((unit, index) => ({
        ...unit,
        order: index + 1,
      }));

      const newUnits = updatedUnits.filter(
        (unit) => !unit.id || unit.id.startsWith("temp-")
      );
      const existingUnits = updatedUnits.filter(
        (unit) => unit.id && !unit.id.startsWith("temp-") && unit.isModified
      );

      const formatUnit = (unit, isExisting) => ({
        ...(isExisting
          ? { docId: unit.id, modifiedBy: userUid }
          : { createdBy: userUid }),
        unitNo: unit.unitNo || "",
        order: unit.order,
        carpetArea: Number(unit.carpetArea) || 0,
        baseRate: Number(unit.baseRate) || 0,
        saleableArea: Number(unit.saleableArea) || 0,
        basePrice: Number(unit.baseRate) * Number(unit.saleableArea) || 0,
        allInclusiveCharges: Number(unit.allInclusiveCharges) || 0,
        buildUpArea: Number(unit.buildUpArea) || 0,
        terraceArea: Number(unit.terraceArea) || 0,
        guidelineSqftPrice: Number(unit.guidelineSqftPrice) || 0,
        totalBhk: Number(unit.totalBhk) || 0,
        notes: unit.notes || "",
        bathrooms: Number(unit.bathrooms) || "",
        unitFloor: Number(unit.floors) || 0,
        registrationCharge: Number(unit.registrationCharge) || 0,
        furnished: unit.furnished || "",
        parking: unit.parking || "",
        coveredParking: unit.coveredParking || "",
        lift: unit.lift || "",
        balconyDirection: unit.balconyDirection || "",
        balconyView: unit.balconyView || "",
        unitStatusId: unit.unitStatus?.id || "",
        propertyId: propertyId,
        towerId: towerId,
        unitFloor: Number(unit.floors) || 0,
      });

      if (newUnits.length > 0) {
        const createPayload = {
          docId: propertyId,
          units: newUnits.map((unit) => formatUnit(unit, false)),
        };
        await PropertiesService.createApartmentUnit(createPayload);
      }

      if (existingUnits.length > 0) {
        const updatePayload = {
          docId: propertyId,
          units: existingUnits.map((unit) => formatUnit(unit, true)),
        };
        await PropertiesService.updateApartmentUnit(updatePayload);
      }

      if (newUnits.length > 0 || existingUnits.length > 0) {
        showSuccessToast("Units saved successfully!");
        setHasChanges(false);
      }
    } catch (error) {
      console.error("Error saving units:", error);
    } finally {
      setLoading(false);
      handleSetLoading(false)
    }
  };

  console.log("totalUnits :::::" ,totalUnits)

  const handleTabChange = async (towerId) => {

    if (hasChanges) {
      await saveUnitsForTower(selectedTower);
    }
    setSelectedTower(towerId);
    setEditingUnit(null);
    setIsSliderOpen(false);
  };

  const handleTotalUnitsChange = (e) => {
    const newValue = Number(e.target.value) || 0;
    setTotalUnits(newValue);
    const tower = towers.find((t) => t.id === selectedTower);
    if (tower) {
      onTotalUnitsChange(tower.towerNum, newValue);
    }
  };

  const handleAddUnit = () => {
    const defaultStatus = plotStatusIds.find(
      (status) => status.label === "Available"
    );
    const tower = towers.find((t) => t.id === selectedTower);
    const currentUnitCount = localUnits.filter((u) => u && !u.isArchived).length;

    const newUnit = {
      id: `temp-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      order: currentUnitCount + 1,
      unitNo: "",
      carpetArea: 0,
      buildUpArea: 0,
      terraceArea: 0,
      saleableArea: 0,
      guidelineSqftPrice: 0,
      floors: 0,
      totalBhk: 0,
      basePrice: 0,
      baseRate: 0,
      allInclusiveCharges: 0,
      bathrooms: "",
      roadFacingSide: "",
      registrationCharge: 0,
      furnished: "",
      parking: "",
      coveredParking: "",
      lift: "",
      balconyDirection: "",
      balconyView: "",
      statusName : defaultStatus.label ,
      notes: "",
      unitStatus: defaultStatus
        ? { id: defaultStatus.id, name: defaultStatus.label }
        : { id: "", name: "N/A" },
      createdBy: userUid,
      towerId: selectedTower,
      towerNum: tower?.towerNum || 1,
    };

    if (exitingTotalUnits > 0) {
     // console.log(tower?.length)
      setTotalUnits(localUnits.length + 1);
    }


    // if (isEdit) {
    //   setTotalUnits(localUnits.length + 1);
    // }

    setEditingUnit(newUnit);
    setIsNewUnit(true);
    setIsSliderOpen(true);
    onAdd(newUnit);
  };
  
const handleEditUnit = (unit) => {
  setEditingUnit({
    ...unit,
    statusName: unit.unitStatus?.name || "",
  });
  setIsNewUnit(false);
  setIsSliderOpen(true);
  onEdit(unit);
};

  const handleUnitFormChange = (e) => {
    const { name, value } = e.target;

    setEditingUnit((prev) => {
      if (name === "unitStatus") {
        const selectedStatus = plotStatusIds.find(
          (status) => status.id === value
        );
        return {
          ...prev,
          unitStatus: {
            id: value,
            name: selectedStatus ? selectedStatus.label : "",
          },    
        };
      }

      if (name === "roadFacingSide") {
        const selectedSide = roadFacingSides.find((side) => side.id === value);
        return {
          ...prev,
          roadFacingSide: {
            id: value,
            name: selectedSide ? selectedSide.label : "",
          },
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleFloorsChange = (e) => {
    const floors = Number(e.target.value);
    setEditingUnit((prev) => {
      const newFloorsBhk = Array(floors)
        .fill()
        .map((_, i) => ({
          floor: i + 1,
          bhk: prev.floorsBhk?.[i]?.bhk || 0,
        }));
      const totalBhk = newFloorsBhk.reduce(
        (sum, item) => sum + Number(item.bhk),
        0
      );
      return {
        ...prev,
        floors,
        totalBhk,
      };
    });
  };

  const handleFloorBhkChange = (index, value) => {
    setEditingUnit((prev) => {
      const newFloorsBhk = [...prev.floorsBhk];
      newFloorsBhk[index] = { ...newFloorsBhk[index], bhk: Number(value) };
      const totalBhk = newFloorsBhk.reduce(
        (sum, item) => sum + Number(item.bhk),
        0
      );
      return {
        ...prev,
        floorsBhk: newFloorsBhk,
        totalBhk,
      };
    });
  };

  const handleApplyToAllUnits = () => {
    const fieldsToApply = {
      guidelineSqftPrice: editingUnit.guidelineSqftPrice,
      registrationCharge: editingUnit.registrationCharge,
      furnished: editingUnit.furnished,
      parking: editingUnit.parking,
      coveredParking: editingUnit.coveredParking,
      lift: editingUnit.lift,
      swimmingPool: editingUnit.swimmingPool,
      villaViewType: editingUnit.villaViewType,
    };

    setLocalUnits((prevUnits) =>
      prevUnits.map((unit, index) =>
        unit
          ? {
            ...unit,
            ...fieldsToApply,
            isModified: true,
            order: index + 1,
          }
          : null
      )
    );

    setHasChanges(true);
    showSuccessToast("Applied settings to all units!");
    setIsSliderOpen(false);
    setEditingUnit(null);
  };

  const handleSaveUnit = async () => {
    if (!editingUnit.unitNo.trim()) {
      showErrorToast("Unit number is required!");
      return;
    }
    if (
      localUnits.some(
        (unit) =>
          unit &&
          unit.unitNo === editingUnit.unitNo &&
          unit.id !== editingUnit.id
      )
    ) {
      showErrorToast("Unit number already exists!");
      return;
    }
    if (editingUnit.unitNo.length > 5) {
      showErrorToast("Unit number cannot exceed 5 characters!");
      return;
    }
    if (!editingUnit.buildUpArea || editingUnit.buildUpArea <= 0) {
      showErrorToast("Build-Up Area must be greater than 0!");
      return;
    }
    if (!editingUnit.saleableArea || editingUnit.saleableArea <= 0) {
      showErrorToast("Saleable Area must be greater than 0!");
      return;
    }
    if (editingUnit.floors < 0 || editingUnit.floors > 6) {
      showErrorToast("Number of floors must be between 0 and 6!");
      return;
    }
    if (editingUnit.totalBhk <= 0 || editingUnit.totalBhk > 10) {
      showErrorToast("Total BHK must be between 1 and 10!");
      return;
    }
    if (!editingUnit.baseRate || editingUnit.baseRate <= 0) {
      showErrorToast("Base Rate must be greater than 0!");
      return;
    }

    try {
      const unitToSave = {
        ...editingUnit,
        propertyId: propertyId,
        createdBy: userUid,
        modifiedBy: userUid,
      };

      if (isNewUnit) {
        setLocalUnits((prevUnits) => {
          const newUnits = [...prevUnits];
          const orderIndex = editingUnit.order - 1;
          const newUnit = {
            ...unitToSave,
            id: unitToSave.id,
            isNew: true,
          };

          while (orderIndex >= newUnits.length) {
            newUnits.push(null);
          }

          newUnits[orderIndex] = newUnit;

          return newUnits;
        });
      } else {
        setLocalUnits((prevUnits) => {
          const updatedUnits = prevUnits.map((unit) =>
            unit && unit.id === editingUnit.id
              ? { ...unitToSave, isModified: true }
              : unit
          );
          return updatedUnits;
        });
      }

      setHasChanges(true);
      setIsSliderOpen(false);
      setEditingUnit(null);
    } catch (error) {
      console.error("Error saving unit:", error);
      showErrorToast("Failed to save unit!");
    }
  };

  const handleCancelUnitEdit = () => {
    setIsSliderOpen(false);
    setEditingUnit(null);
  };

  const getStatusStyles = (status) => {
    switch (status?.toLowerCase()) {
      case "available":
        return "bg-green-100 text-green-800";
      case "booked":
        return "bg-yellow-100 text-yellow-800";
      case "sold":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const activeTower = towers.find((t) => t.id === selectedTower) || towers[0] || {};

  const tableRows = isSliderOpen && !isNewUnit
    ? localUnits
      .filter((unit) => unit && !unit.isArchived && !unit.isPlaceholder)
      .map((unit) => ({
        ...unit,
      }))
    : Array.from({ length: totalUnits }, (_, index) => {
      const unit = localUnits.find((u) => u && u.order === index + 1 && !u.isArchived);
      return (
        unit || {
          id: `placeholder-${index}`,
          order: index + 1,
          unitNo: `Unit ${index + 1}`,
          saleableArea: 0,
          buildUpArea: 0,
          floors: 0,
          totalBhk: 0,
          baseRate: 0,
          basePrice: 0,
          unitStatus: { id: "", name: "N/A" },
          isPlaceholder: true,
        }
      );
    });

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      {/* Tower Tabs */}
      <ToastContainer/>
      <div className="flex flex-wrap items-center justify-between mb-6">
        <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500">
          {towers.map((tower) => (
            <div key={tower.id} className="me-2">
              <button
                onClick={() => handleTabChange(tower.id)}
                className={` px-4 py-3 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 ${selectedTower === tower.id
                    ? "bg-white text-customGreen shadow-[0_4px_6px_0_rgba(0,0,0,0.1),0_-4px_6px_0_rgba(0,0,0,0.1),-4px_0_6px_0_rgba(0,0,0,0.1),4px_0_6px_0_rgba(0,0,0,0.1)]"
                    : "hover:text-gray-900 hover:bg-gray-100 border"
                  } ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                disabled={loading}
              >
                {tower.towerName || `Tower ${tower.towerNum}`}
              </button>

            </div>
          ))}
        </ul>

        {isEdit ? (
          <div className="flex items-center gap-3 p-2 bg-white rounded-md border-2 border-slate-200">
            <label className="flex items-center text-sm font-medium text-gray-700 whitespace-nowrap">
              <span className="inline-block w-1.5 h-4 bg-red-400 rounded-sm mr-2"></span>
              Units in {activeTower.towerName || `Tower ${activeTower.towerNum}`}
            </label>
            <input
              type="number"
              min={localUnits.filter((u) => u && !u.isArchived).length}
              value={totalUnits !== 0 ? totalUnits : ""}
              disabled={localUnits?.length > 0 ? true : false}
              onChange={handleTotalUnitsChange}
              placeholder="Units No"
              className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm input-focus transition duration-150 ease-in-out"
            />
          </div>
        ) : (
          <div className="flex items-center gap-3 p-2 bg-white rounded-md border-2 border-slate-200">
            <label className="flex items-center text-sm font-medium text-gray-700 whitespace-nowrap">
              <span className="inline-block w-1.5 h-4 bg-red-400 rounded-sm mr-2"></span>
              Units in {activeTower.towerName || `Tower ${activeTower.towerNum}`}
            </label>
            <input
              type="number"
              min={localUnits.filter((u) => u && !u.isArchived).length}
              value={totalUnits !== 0 ? totalUnits : ""}
              onChange={handleTotalUnitsChange}
              placeholder="Units No"
              className="w-24 px-3 py-2 border border-gray-300 rounded-md text-sm input-focus transition duration-150 ease-in-out"
            />
          </div>
        )}
      </div>

      {/* Unit Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-100 text-base text-center rounded-md">
              <th className="px-4 py-3 text-gray-700 font-medium">Unit No.</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Saleable Area</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Build-Up Area</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Unit Floors</th>
              <th className="px-4 py-3 text-gray-700 font-medium">BHK</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Base Rate</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Base Price</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Status</th>
              <th className="px-4 py-3 text-gray-700 font-medium">Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="text-center">
                <td colSpan={9} className="py-8 text-gray-500">
                  Loading...
                </td>
              </tr>
            ) : tableRows.length > 0 ? (
              tableRows.map((row) => (
                <tr
                  key={row.id}
                  className="border-b text-center border-gray-200 hover:bg-gray-50"
                >
                  <td className="px-4 text-sm py-4">{row.unitNo}</td>
                  <td className="px-4 py-4 text-sm">{row.saleableArea}</td>
                  <td className="px |4 py-4 text-sm">{row.buildUpArea}</td>
                  <td className="px-4 py-4 text-sm">{row.floors}</td>
                  <td className="px-4 py-4 text-sm">{row.totalBhk}</td>
                  <td className="px-4 py-4 text-sm">{row.baseRate}</td>
                  <td className="px-4 py-4 text-sm font-medium">{row.basePrice}</td>
                  <td className="px-4 py-4">
                    <span
                      className={`px-3 py-1 text-xs rounded-full ${getStatusStyles(
                        row.unitStatus.name
                      )}`}
                    >
                      {row.unitStatus?.name}
                    </span>
                  </td>
                  {row.unitStatus?.name === "Available" || row?.unitStatus?.name === "N/A" ? (

                    <td className="px-4 py-4">
                      {row.isPlaceholder ? (
                        <button
                          onClick={() => handleAddUnit()}
                          className="p-1 px-2 bg-customGreen text-white rounded-md transition-colors flex items-center justify-center"
                          aria-label="Add unit"
                        >
                          <span className="text-sm">Add</span>
                        </button>
                      ) : (
                        <button
                          onClick={() => handleEditUnit(row)}
                          className="p-2 text-customGreen hover:bg-blue-50 rounded-md transition-colors"
                          aria-label="Edit unit"
                        >
                          <FiEdit size={20} />
                        </button>
                      )}
                    </td>
                  ) : (
                    <td  onClick={() => handleEditUnit(row)} className="text-center flex items-center justify-center text-2xl mt-4 cursor-pointer hover:text-customGreen">
                      <RiFileInfoLine />
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan={9} className="py-8 text-gray-500">
                  No units found for this tower
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={9} className="px-4 py-4 text-center">
                <button
                  onClick={handleAddUnit}
                  className="px-4 py-2 bg-customGreen text-white rounded-md transition-colors flex items-center mx-auto"
                >
                  <MdAddCircleOutline className="mr-2" />
                  Add New Unit
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Unit Form Slider */}
      {isSliderOpen && editingUnit && (
        <ApartmentUnitForm
          isSliderOpen={isSliderOpen}
          onHide={handleCancelUnitEdit}
          unit={editingUnit}
          handleChange={handleUnitFormChange}
          handleUnitFormChange={handleUnitFormChange}
          handleSave={handleSaveUnit}
          handleCancel={handleCancelUnitEdit}
          handleFloorsChange={handleFloorsChange}
          handleFloorBhkChange={handleFloorBhkChange}
          handleApplyToAll={handleApplyToAllUnits}
          isNew={isNewUnit}
        />
      )}
    </div>
  );
};

export default ApartmentUnitTable;